"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operation_types_map = exports.operation_type_list = exports.operation_types = void 0;
const util_1 = require("./util");
exports.operation_types = [
    {
        key: 'planting',
        tupuake_id: 1,
        display_name: 'Planting',
    },
    {
        key: 'clearing',
        tupuake_id: 2,
        display_name: 'Clearing',
    },
    {
        key: 'historic_clearing',
        tupuake_id: 3,
        display_name: 'Historic Clearing',
    },
];
exports.operation_type_list = exports.operation_types.map((sp) => sp.key);
exports.operation_types_map = (0, util_1.toMap)(exports.operation_types);
